var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-layout',{staticClass:"shadow-2 rounded-borders vonix-phone-classes",attrs:{"view":"hHh lpr fFf","bordered":""}},[_c('q-page-container',[_c('q-page',{staticClass:"vonix-font bg-white",attrs:{"style-fn":_vm.myTweak}},[_c('router-view'),_c('InnerOffer')],1)],1),_c('audio',{staticStyle:{"display":"none"},attrs:{"id":"remoteAudio"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }